// extracted by mini-css-extract-plugin
export default {"brand":"Header_brand__5ovdD","subText":"Header_subText__llgwu","line":"Header_line__Nl0pD"};